import React from 'react';
export function Input({label, hint, error, prefix, style, inputStyle, ...rest}) {
  const [focus, setFocus] = React.useState(false);
  return <label style={{display:'flex',flexDirection:'column',gap:6,fontFamily:'var(--font-sans)',fontSize:'var(--text-sm)',...style}}>
    {label && <span style={{fontWeight:600,color:'var(--text-body)'}}>{label}</span>}
    <span style={{display:'flex',alignItems:'center',gap:8,background:'var(--surface)',border:'1px solid '+(error?'var(--danger)':focus?'var(--brand)':'var(--border-strong)'),
      borderRadius:'var(--radius-md)',padding:'0 12px',height:40,boxShadow:focus?'var(--focus-ring)':'none',transition:'box-shadow var(--dur-fast) var(--ease-out)'}}>
      {prefix && <span style={{color:'var(--text-muted)'}}>{prefix}</span>}
      <input onFocus={()=>setFocus(true)} onBlur={()=>setFocus(false)}
        style={{flex:1,border:'none',outline:'none',background:'transparent',font:'inherit',color:'var(--text-body)',minWidth:0,...inputStyle}} {...rest}/>
    </span>
    {error ? <span style={{color:'var(--danger)'}}>{error}</span> : hint ? <span style={{color:'var(--text-muted)'}}>{hint}</span> : null}
  </label>;
}
